(function () {
  'use strict';

  if (typeof window._AutofillCallbackHandler === 'undefined') {
    window._AutofillCallbackHandler = function () {};
  }

  var ua = navigator.userAgent || '';
  var isIG = /Instagram/.test(ua) || /FBAN|FBAV/.test(ua);

  if (!isIG) return;

  document.documentElement.dataset.lmWebview = 'ig';

  function tagClarity() {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'in_app_browser', 'instagram');
        return true;
      }
    } catch (e) {}
    return false;
  }

  if (!tagClarity()) {
    window.addEventListener('load', tagClarity);
  }
})();
